import { z } from 'zod';
import { IsoDateTime, PageMeta, PageRequest } from './_common.js';
export const AuditLogEntry = z.object({
    id: z.number().int(),
    actor_admin_id: z.string(),
    actor_email: z.string().email(),
    actor_role: z.string(),
    action: z.string(),
    target_type: z.string(),
    target_id: z.string(),
    payload: z.record(z.unknown()),
    ip_address: z.string().nullable(),
    user_agent: z.string().nullable(),
    result: z.enum(['success', 'denied', 'error']),
    reason: z.string().nullable(),
    ts: IsoDateTime,
});
export const AuditLogListRequest = PageRequest.extend({
    actor_admin_id: z.string().optional(),
    action: z.string().optional(),
    target_type: z.string().optional(),
    target_id: z.string().optional(),
    result: z.enum(['success', 'denied', 'error']).optional(),
    ts_after: IsoDateTime.optional(),
    ts_before: IsoDateTime.optional(),
});
export const AuditLogListResponse = z.object({
    items: z.array(AuditLogEntry),
    page: PageMeta,
});
//# sourceMappingURL=audit_logs.js.map